var map = {
	"./locale-provider/bg_BG.tsx": 967,
	"./locale-provider/ca_ES.tsx": 968,
	"./locale-provider/cs_CZ.tsx": 969,
	"./locale-provider/de_DE.tsx": 970,
	"./locale-provider/en_GB.tsx": 971,
	"./locale-provider/en_US.tsx": 972,
	"./locale-provider/es_ES.tsx": 973,
	"./locale-provider/et_EE.tsx": 974,
	"./locale-provider/fi_FI.tsx": 975,
	"./locale-provider/fr_BE.tsx": 976,
	"./locale-provider/fr_FR.tsx": 977,
	"./locale-provider/it_IT.tsx": 978,
	"./locale-provider/ja_JP.tsx": 979,
	"./locale-provider/ko_KR.tsx": 980,
	"./locale-provider/nl_BE.tsx": 981,
	"./locale-provider/nl_NL.tsx": 982,
	"./locale-provider/pl_PL.tsx": 983,
	"./locale-provider/pt_BR.tsx": 984,
	"./locale-provider/ru_RU.tsx": 985,
	"./locale-provider/sk_SK.tsx": 986,
	"./locale-provider/sv_SE.tsx": 988,
	"./locale-provider/tr_TR.tsx": 989,
	"./locale-provider/vi_VN.tsx": 990,
	"./locale-provider/zh_TW.tsx": 991
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 853;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 853
// module chunks = 0